import React from "react";
import { countries } from "country-flag-icons";

function FooterComponent() {
  return (
    <div>
      <footer id="footer" className="footer position-relative dark-background">
        <div className="container footer-top">
          <div className="row gy-4">
            <div className="col-lg-4 col-md-6 footer-about">
              <a href="index.html" className="logo d-flex align-items-center">
                <img alt="symventures" src="assets/img/logo-white.png" />
              </a>
              <div className="footer-contact pt-3">
                <p>2nd floor, Maitreya Business Park,</p>
                <p>Hanuman road, above Mad Over Doughnuts,</p>
                <p>opp. Parleshwar Mandir, Vile Parle (East),</p>                
                <p>Mumbai - 400057, India</p>
                <p>
                  <strong>Email:</strong> <span>info@symventures.com</span>
                </p>
              </div>             
            </div>

            <div className="col-lg-3 col-md-4 footer-links">
              <h3>
                INDIA{" "}
                <img
                  alt="United States"
                  height={"32px"}
                  src="http://purecatamphetamine.github.io/country-flag-icons/3x2/IN.svg"
                />
              </h3>
              <p>SYM Ventures LLP</p>
              <p>SYM Hospitality Pvt. Ltd.</p>
              <p>SYM Space Pvt. Ltd.</p>
              <p>SYM Commercial Pvt. Ltd.</p>
              <p>SYM Healthcare Pvt. Ltd.</p>
            </div>

            <div className="col-lg-3 col-md-3 footer-links">
              <h3>
                AFRICA{" "}
                <img
                  alt="United States"
                  height={"32px"}
                  src="http://purecatamphetamine.github.io/country-flag-icons/3x2/GH.svg"
                />
              </h3>
              <p>Indo Guinee Gold Sarl</p>
              <h3>
                SINGAPORE{" "}
                <img
                  alt="United States"
                  height={"32px"}
                  src="http://purecatamphetamine.github.io/country-flag-icons/3x2/SG.svg"
                />
              </h3>
              <p>SYM Investment PTE Ltd</p>
              <p> Singapore Trading Enterprises Pte Ltd</p>
            </div>

            <div className="col-lg-2 col-md-12 footer-newsletter">
              <h3>
                UAE{" "}
                <img
                  className="img"
                  alt="UAE"
                  src="http://purecatamphetamine.github.io/country-flag-icons/3x2/AE.svg"
                  height={"32px"}
                />
              </h3>
              <p>Stagelife Events LLC</p>
            </div>
          </div>
        </div>

        <div className="container copyright text-center mt-4">
          <p>
            © 2025<span>Copyright</span>{" "}
            <strong className="px-1 sitename">SYM Ventures</strong>
            <span>All Rights Reserved</span>
          </p>
        </div>
      </footer>
    </div>
  );
}

export default FooterComponent;
